const EstatisticasSection = () => (
  <div id='separador-matricula'>
    <div className="stat-item">
      <span className="stat-number">+10</span>
      <p>Anos de excelência</p>
    </div>
    <div className="stat-item">
      <span className="stat-number">+25</span>
      <p>Professores qualificados</p>
    </div>
    <div className="stat-item">
      <span className="stat-number">+500</span>
      <p>Alunos formados</p>
    </div>
  </div>
);

export default EstatisticasSection;
